import { styled } from '@mui/material';

import type { RadioProps } from '@mui/material';
import type { ColorType } from '@shared/ui-kit/controls/MuiRadioButton/MuiRadioButton';

export const RadioButtonIcon = styled('span', {
  shouldForwardProp: (prop: string) => !['isError', 'size'].includes(prop),
})<{ isError: boolean; size: RadioProps['size']; color: ColorType }>(({ theme, isError, size, color }) => ({
  borderRadius: '50%',
  border: `2px solid ${isError ? theme.palette.case.red.r600 : theme.palette.case.neutral.n400}`,
  width: size === 'small' ? 16 : 20,
  height: size === 'small' ? 16 : 20,
  background: theme.palette.case.neutral.n0,

  'input:hover ~ &': {
    borderColor: isError
      ? theme.palette.case.red.r600
      : color === 'primary'
        ? theme.palette.case.aquamarine.a800
        : theme.palette.case.neutral.n800,
  },
  'input:disabled ~ &': {
    borderColor: theme.palette.case.neutral.n200,
  },
}));

export const RadioButtonCheckedIcon = styled(RadioButtonIcon)(({ theme, size, color, isError }) => ({
  border: `2px solid ${
    isError
      ? theme.palette.case.red.r600
      : color === 'primary'
        ? theme.palette.case.aquamarine.a900
        : theme.palette.case.neutral.n900
  }`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:before': {
    display: 'block',
    width: size === 'small' ? 8 : 10,
    height: size === 'small' ? 8 : 10,
    borderRadius: '50%',
    backgroundColor: isError
      ? theme.palette.case.red.r600
      : color === 'primary'
        ? theme.palette.case.aquamarine.a900
        : theme.palette.case.neutral.n900,
    content: '""',
  },

  'input:hover ~ &': {
    '&:before': {
      backgroundColor: isError
        ? theme.palette.case.red.r600
        : color === 'primary'
          ? theme.palette.case.aquamarine.a800
          : theme.palette.case.neutral.n800,
    },
  },
  'input:disabled ~ &': {
    borderColor: theme.palette.case.neutral.n200,

    '&:before': {
      display: 'block',
      opacity: 1,
      width: size === 'small' ? 8 : 10,
      height: size === 'small' ? 8 : 10,
      backgroundColor: theme.palette.case.neutral.n200,
      borderRadius: '50%',
      content: '""',
    },
  },
}));
